import React from "react";

import { 
    SectionHeaderContainer,
    Header2 
} from "../Styles"

export const SectionHeader = ({ title, children }) => {
    return (
        <SectionHeaderContainer>
            <Header2>{title}</Header2>
            {children}
        </SectionHeaderContainer>
    )
}
